import React, { Component } from 'react';
import _ from 'lodash';

import { Grid, Link, Paper, Typography } from '@material-ui/core';

import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import ContentData from '../../types/ContentData';
import ReactPlayer from 'react-player';
import { MyPATLink } from '../../../common';
import { getThumbnailSource } from '../../../../utils';
import ConceptIncludesPopup from './ConceptIncludesPopup';
import * as JSLZString from 'lz-string';

declare var window: any;

const styles = (theme: Theme) => createStyles({
	paperOverview: {
		padding: theme.spacing.unit * 2,
		boxShadow: "0px 0px 10px 0px #0000001F",		
		'& img':{
			display: 'block',
			maxWidth: '100%',
		}
	},
	keyValueContainer: {
		'& *': {
			display: 'inline',
			marginRight: '4px',
		},
		marginTop: theme.spacing.unit * 2,
	},
	overviewMeta: {
		opacity: 0.6
	},
	metaInfoBox: {
		padding: theme.spacing.unit,
		marginTop: theme.spacing.unit,
		border: `1px solid ${theme.palette.background.default}`,
		borderRadius: '2px'
	},
	metaInfoBoxTable: {
		border: 0
	},
	titleDesc: {
		paddingLeft: 35,
		paddingTop: 20,
		'& h6':{
			fontSize:15,
			fontWeight:700,
			lineHeight: '20px',
		}
	},
	titleDescContentName: {
		borderBottom: "1px solid #ddd",
		padding: theme.spacing.unit * 2,
		'& h6:nth-of-type(1)':{
			fontWeight: 700,
			fontSize: 20,
		}
	},
	subName: {
		padding: theme.spacing.unit * 2,
		paddingBottom: 0
	},
	conceptContainer: {
		// padding: theme.spacing.unit * 2,
		// paddingLeft: 25,
		paddingTop: 0,
		'& h6':{
			marginBottom: 8,
		}
	},
	paperContainer: {
		marginBottom: theme.spacing.unit * 2,
		paddingBottom: 16,
		boxShadow: "0px 0px 10px 0px #0000001F",		
	},
	borderContainer:{
		border: "1px solid #E1E1E1"	,
		margin: '20px 20px 0 20px',
		padding: 10,
		borderRadius: 4,
	},
	font16:{
		fontSize: 16,
	},
	fontBold:{
		fontWeight: 700,
	},
	titleContainer:{
		marginLeft: -15,
		marginRight: -15,
		marginTop: -15,
		marginBottom: 15,
	},
	thumbTitle:{
		fontSize: 16,
		fontWeight: 400,
		lineHeight: '16px',
		margin: '20px 0',
	},
	displayFlex:{
		display: "flex",
		'& h6':{
			flexBasis: "5%",	
			fontSize: 15,
			fontWeight: 700,
		},
		'& p':{
			margin: 0,
			flexBasis: "95%",		
		},
	},
	quesHeader:{
		'& h6':{
			fontSize:15,
			fontWeight:700,
			lineHeight: '20px',
		}
	},
	cursor: {
		cursor: 'pointer',
		fontWeight: 700,
	}
});



//@ts-ignore
interface VideoPreviewProps extends WithStyles<typeof styles> {
	classes: any,
	content: ContentData
}

interface VideoPreviewStates {
	showAllConcepts: boolean;
}

const secondsToTime = (totalSeconds: any) => {
	var hours = Math.floor(totalSeconds / (60 * 60));
console.log({totalSeconds});
	var divisor_for_minutes = totalSeconds % (60 * 60);
	var minutes = Math.floor(divisor_for_minutes / 60);

	var divisor_for_seconds = divisor_for_minutes % 60;
	var seconds = Math.ceil(divisor_for_seconds);
console.log({seconds});
	// var obj = {
	// 	"HH": hours,
	// 	"MM": minutes,
	// 	"SS": seconds
	// };

	var obj = {
		"HH": (hours <= 9) ? `0${hours}` : `${(hours)}`,
		"MM": (minutes <= 9) ? `0${minutes}` : `${(minutes)}`,
		"SS": (seconds <= 9) ? `0${seconds}` : `${(seconds)}`
	  };
	return obj;
}

class VideoPreview extends Component<VideoPreviewProps, VideoPreviewStates>{

	state: VideoPreviewStates = {
		showAllConcepts: false
	}

	toggleAllConcepts = () => {
		this.setState(prevState => {
			return {
				...prevState,
				showAllConcepts: !prevState.showAllConcepts
			}
		})
	}

	getConceptsTagged() {
		const { content, classes } = this.props;

		return _.reduce(
			_.get(content, "subjects", []),
			(acc: JSX.Element[], subject) => {
				subject.chapters && subject.chapters.forEach((chapter) => {
					chapter.concepts.forEach((concept) => {
						let conceptName = _.get(concept, "conceptId.name");
						let conceptCode = _.get(concept, "conceptCode");
						if (conceptName) {
							acc.push(
								<Typography variant="body1">
									{conceptName}{" "}
									{conceptCode && (
										<Typography variant="h6" inline className={[classes.font16, classes.fontBold].join(' ')}>
											(ID: {conceptCode})
										</Typography>
									)}
								</Typography>
							);
						}
					});
				});
				return acc;
			},
			[]
		);
	}

	onReadyPlayer(e: any) {
		let videoId;
		if (window.location.href.includes('note')) {
		  videoId = 'playerNoteId';
		} else {
		  videoId = 'playerVideoId';
		}
		var myVideo = document.getElementById(videoId);
		if(myVideo) {
		  if (myVideo.addEventListener) {
			myVideo.addEventListener('contextmenu', function (e) {
			  e.preventDefault();
			}, false);
		  }
		}
	  }

	render() {
		let { classes, content: contentData } = this.props;
		const { showAllConcepts } = this.state;
		let { content, tags, subjects, secondarySubjects } = contentData
		let videoUrl = _.get(content, "videoUrl", "");
		videoUrl = JSLZString.decompressFromEncodedURIComponent(videoUrl);
		const thumbnailKey = _.get(contentData, "thumbnailUrl", "");
		const videoThumbnail = getThumbnailSource(thumbnailKey);

		const conceptsTagged = this.getConceptsTagged();
		var myVideo = document.getElementById("playerId");
		if(myVideo) {
			if (myVideo.addEventListener) {
				myVideo.addEventListener('contextmenu', function (e) {
					e.preventDefault();
				}, false);
			} else {
				// myVideo.attachEvent('oncontextmenu', function () {
				// 	window.event.returnValue = false;
				// });
			}
		}

		return (
			<>
			<Grid container spacing={16} direction="column">
				<Grid item>
					<Paper  className={` ${classes.paperContainer}`}>
						<div className={classes.titleDescContentName}>
							<Typography variant="title" inline>Content Name: </Typography>
							<Typography variant="subheading" inline>
								Videos
							</Typography>
						</div>
						<div className={classes.subName}>
							<Typography variant="body1">
								{
									_.get(subjects[0], "subjectId.name", "")
								}
							</Typography>
						</div>
						<Grid className={classes.borderContainer}>
							<Grid container xs={12} className={classes.conceptContainer}>
								<Grid item xs={12}>
									<Typography variant="title" className={classes.fontBold}>Concept includes:</Typography>
									{conceptsTagged.slice(0,3)}
									{conceptsTagged.length > 0 && (
										<div>
											<Link
												className={classes.cursor}
												color="primary"
												onClick={this.toggleAllConcepts}
											>
												View all
											</Link>
										</div>
									)}
								</Grid>
							</Grid>
						</Grid>

					</Paper>
					{/* <Paper className={classes.paperOverview}>
						<div className={classes.titleDesc}>
							<Typography variant="title" inline>Title: </Typography>
							<span dangerouslySetInnerHTML={{ __html: _.get(content, "title", "-") }}></span>
						</div>
					</Paper> */}
					{/* <br/> */}
					<Paper className={`${classes.paperOverview} ${classes.paperContainer}`}>
					<Grid className={[classes.titleDescContentName, classes.titleContainer].join(' ')}>
							<Typography variant="title" inline className={classes.fontBold}>Title: </Typography>
							<span dangerouslySetInnerHTML={{ __html: _.get(content, "title", "-") }}></span>
						</Grid>
						<div>
							<Typography variant="body1">
								<span dangerouslySetInnerHTML={{ __html: _.get(content, "description", "-") }}></span>
							</Typography>
						</div>
						<div id="playerId">
							<br /><br />
							<ReactPlayer url={videoUrl}  onReady={(e:any) => this.onReadyPlayer(e)} width="400px" height="200px" controls
							 config={{ file: { attributes: { controlsList: 'nodownload' } } }} />
						</div>
						{
							thumbnailKey && thumbnailKey.length ? (
								<>
								<div className={classes.thumbTitle}>
									<Typography variant="title">Thumbnail </Typography>
								</div>
								<img src={videoThumbnail} alt="Video thumbnail" />
								</>
							) : ''
						}
					</Paper >
					{
						_.get(content, "pages", []).map(({ metaData: { question } }: any, index: number) => {
							let time = _.get(question, "showQuestionAtTime", 0)
							time = secondsToTime(time);
							let {SS = '00', HH = '00', MM = '00' } = time;
							// if (HH < 9) HH = '0' + HH
							// if (MM < 9) MM = '0' + MM
							// if (SS < 9) SS = '0' + SS
							const questionId = _.get(question, "id._id", '') + 'question';
							return (
                <Paper
                  className={`${classes.paperOverview} ${
                    classes.paperContainer
                  }`}
                >
                  <Paper className={classes.paperOverview}>
                    <Grid container xs={12}>
                      <Grid item xs={3}>
                        <div className={classes.quesHeader}>
                          <Typography variant="title">
                            Question Type
                          </Typography>
                          <Typography>
                            {_.get(
                              question,
                              "id.questionType",
                              ""
                            )}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div className={classes.quesHeader}>
                          <Typography variant="title">
                            Difficulty
                          </Typography>
                          <Typography>
                            {_.get(
                              question,
                              "id.difficultyType",
                              []
                            ).join(", ")}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div className={classes.quesHeader}>
                          <Typography variant="title">
                            Attempt Question
                          </Typography>
                          <Typography>
                            {question.attempt
                              ? "Required"
                              : "Optional"}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div className={classes.quesHeader}>
                          <Typography variant="title">
                            Question time
                          </Typography>
                          <Typography>
                            {`${HH}:${MM}:${SS} Sec`}
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                  <br />
                  <br />
                  {/* <Paper className={classes.paperOverview}> */}
                  <div>
                    <Grid className={classes.displayFlex}>
                      <Typography variant="title" inline>
                        {`Q${index + 1}   `}
                      </Typography>
                      &nbsp;
                      <Grid>
                        {
                          <Typography
                            dangerouslySetInnerHTML={{
                              __html: _.get(
                                question,
                                "id.content[0].questionContent",
                                ""
                              ),
                            }}
                          />
                        }

                        <MyPATLink
                          to={`/content/preview/${questionId}`}
                          target="_blank"
                        >
                          <Typography
                            variant="body1"
                            color="primary"
                          >
                            ID:&nbsp;
                            {_.get(question, "id.contentId", "")}
                          </Typography>
                        </MyPATLink>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.titleDesc}>
                    <Typography variant="title">
                      Options are:
                    </Typography>
                    <Typography variant="body1">
                      {_.get(
                        question,
                        "id.content[0].optionsContent",
                        []
                      ).map((option: any = {}, index: number) => {
                        return (
                          <div>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: `${option.serialNo}. ${
                                  option.value
                                }`,
                              }}
                            />
                          </div>
                        );
                      })}
                    </Typography>
                  </div>
                  <div className={classes.titleDesc}>
                    <Typography variant="title">
                      Correct Answer:
                    </Typography>
                    <Typography variant="body1">
                      {
                        <span
                          dangerouslySetInnerHTML={{
                            __html: _.get(
                              question,
                              "id.content[0].correctAnswer.data[0].value",
                              ""
                            ),
                          }}
                        />
                      }
                    </Typography>
                  </div>
                  <div className={classes.titleDesc}>
                    <Typography variant="title">
                      Solutions:
                    </Typography>
                    <Typography variant="body1">
                      {
                        <span
                          dangerouslySetInnerHTML={{
                            __html: _.get(
                              question,
                              "id.content[0].solutionContent",
                              ""
                            ),
                          }}
                        />
                      }
                    </Typography>
                  </div>
                  <div className={classes.titleDesc}>
                    <Typography variant="title">Tags:</Typography>
                    <Typography variant="body1">
                      {tags &&
                        tags.map((t: any, i: any) => (
                          <span key={i}>
                            {_.get(t, "relation.name", "-")}:
                            {_.isArray(_.get(t, "values", "-"))
                              ? _.get(t, "values", "-").join(", ")
                              : _.get(t, "values", "-")}{" "}
                            &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                          </span>
                        ))}
                    </Typography>
                  </div>
                  <div className={classes.titleDesc}>
                    <Typography variant="title">
                      Description:
                    </Typography>
                    <Typography variant="body1">
                      {
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${question.description}`,
                          }}
                        />
                      }
                    </Typography>
                  </div>
                  <div className={classes.titleDesc}>
                    <Typography variant="title">
                      Instructions:
                    </Typography>
                    <Typography variant="body1">
                      {
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${question.instruction}`,
                          }}
                        />
                      }
                    </Typography>
                  </div>
                  <div className={classes.titleDesc}>
                    <Typography variant="title">
                      Additional Options
                    </Typography>
                    <Typography variant="body1">
                      {
                        <Grid
                          container
                          direction="row"
                          spacing={8}
                        >
                          <Grid item>Show solution</Grid>
                          <Grid item>Show hint</Grid>
                        </Grid>
                      }
                    </Typography>
                  </div>
                  {/* </Paper> */}
                </Paper>
              );
						})
					}
				</Grid>
			</Grid>
			{!!showAllConcepts && (
				<ConceptIncludesPopup
					onClose={this.toggleAllConcepts}
					primaryConcepts={conceptsTagged}
					conceptType="primary"
				/>
			)}
			</>
		)
	}
}


// @ts-ignore
export default withStyles(styles)(VideoPreview);